import { Table } from 'antd';
import React from 'react';

/** Lá (leaf) của cây cột antd — thứ tự đúng như cột hiển thị. */
const flattenLeaves = (columns: any[]): any[] =>
  (columns || []).flatMap((col) => (col?.children?.length ? flattenLeaves(col.children) : [col]));

/**
 * Dòng tổng: gọi lại đúng hàm render của từng cột tiền với `summaryRecord` (bản ghi đã cộng dồn
 * toàn đợt do BE trả về) → công thức footer luôn trùng công thức của cột, kể cả cột động theo tên.
 * Cột nền (mã NV, tên, line, vị trí, ngày, trạng thái, action) để trống.
 */
export const buildSummaryRow =
  ({
    columns,
    baseDataIndexes,
    summaryRecord,
    label,
    hasSelection,
  }: {
    columns: any[];
    baseDataIndexes: string[];
    summaryRecord: any;
    label: string;
    hasSelection: boolean;
  }) =>
  () => {
    if (!summaryRecord) return null;
    const topLevelBase = new Set(baseDataIndexes);
    const leaves: { col: any; isBase: boolean }[] = [];
    for (const top of columns || []) {
      const isBase = topLevelBase.has(top?.dataIndex);
      for (const leaf of flattenLeaves([top])) leaves.push({ col: leaf, isBase });
    }
    const offset = hasSelection ? 1 : 0;
    let labelPlaced = false;
    return (
      <Table.Summary fixed="bottom">
        <Table.Summary.Row style={{ fontWeight: 600, background: '#fafafa' }}>
          {hasSelection && <Table.Summary.Cell index={0} />}
          {leaves.map(({ col, isBase }, i) => {
            let content: any = null;
            if (isBase) {
              if (!labelPlaced && col?.dataIndex !== 'action') {
                content = label;
                labelPlaced = true;
              }
            } else if (typeof col?.render === 'function') {
              content = col.render(undefined, summaryRecord, -1);
            }
            return (
              <Table.Summary.Cell
                key={`${col?.key || col?.dataIndex || 'c'}-${i}`}
                index={i + offset}
                align={isBase ? 'left' : col?.align || 'right'}
              >
                {content}
              </Table.Summary.Cell>
            );
          })}
        </Table.Summary.Row>
      </Table.Summary>
    );
  };
